export const isExpiredOffer = (expirationDate: string): boolean => {
  const now = new Date();
  const expiration = new Date(expirationDate);
  return now > expiration;
};
